<template>
  <div id="routes">
    <app-content>
      <div class="flex flex-sb-c">
        <h1 class="no-margin">{{ $t('nav.routes') }}
          <span v-if="!loading">({{ routes.length }}/{{ store.user.permission('LIMIT_ROUTES') }})</span>
        </h1>
        <div class="buttons">
          <AppButton @click="$router.push('/account')" color="primary" v-if="routes.length >= store.user.permission('LIMIT_ROUTES')">Få flere ruter</AppButton>
          <AppButton @click="createRoute()" color="primary" :disabled="routes.length >= store.user.permission('LIMIT_ROUTES')">Opret rute</AppButton>
        </div>
      </div>
      <div id="routes_list" v-if="!loading">
        <RouteThumbnail v-for="route in routes" :route="route" :key="route.id" />
        <div v-if="!routes.length" class="text-c card">
          <h2>Du har ikke nogen ruter</h2>
          <p>Det skal du ikke være ked af. Det er helt gratis og super nemt, at oprette en rute. Hvad venter du på?</p>
          <AppButton @click="createRoute()" color="primary">Opret din første rute</AppButton>
        </div>
      </div>
      <div v-else class="flex flex-c-c"><AppLoader /></div>
    </app-content>
    <app-content>
    <div>
      <h2>Hvor er mine ruter?</h2>
      <p>Frygt ej, de er i god behold! Da vi er flyttet til en ny platform skal du manuelt flytte dine ruter. Det tager kun få sekunder! <a href="https://old.tripply.dk/upgrade">Læs hvordan du gør her</a></p>
    </div>
    </app-content>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref } from 'vue'
import { store } from '@/store'
import RouteThumbnail from '@/components/routes/RouteThumbnail.vue'
import AppContent from '@/components/layout/AppContent.vue'

export default defineComponent({
  name: 'UserRoutes',
  components: { AppContent, RouteThumbnail },
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      await store.user.fetchUserRoutes()      
      loading.value = false
    })
    
    const user = store.user.get(state => state)
    const routes = computed(() => store.user.getUserRoutes())

    function createRoute() {
      store.modal.showModal('CreateRoute')
    }

    return { user, loading, createRoute, store, routes }
  }
})
</script>

<style lang="scss" scoped>
h1 span {
  display: inline-block;
  transform: scale(0.75);
}
#routes_list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  margin-top: 2rem;
}
</style>